<template>
  <div>
    <v-list
      class="mb-1 mt-1 py-0"
      three-line
    >
      <template v-for="order in orders">
        <v-list-item
          :key="order[fieldOrderId]"
          :class="isDarkMode ? 'grey darken-4' : 'grey lighten-3'"
          :style="deliverAction ? 'min-height: 110px;' : 'min-height: 83px;'"
          class="px-1 py-1 px-sm-4 align-start"
          ripple
          @click="onListTileClick(order)"
        >
          <div
            class="text-caption pr-1"
            style="display: grid !important;"
          >
            <v-chip
              :class="order.IsEdited ? 'pl-0 pr-1' : 'px-1 text-center'"
              :color="parseInt(order[fieldStatusId]) !== 19 ? 'green' : 'red'"
              :small="dense"
              class="white--text mb-1 d-flex-"
              label
              style="display: inline-block; min-width: 65px;"
            >
              <v-avatar
                v-if="order.IsEdited"
                class="mr-1"
                color="purple"
                size="20"
                tile
              >
                <v-icon
                  dark
                  small
                  v-text="$t('Order.OrdersAll.ListView.Button.Edit.Icon')"
                />
              </v-avatar>

              <strong>{{ '#' + order[fieldOrderCode] }}</strong>
            </v-chip>

            <template v-if="parseInt(order[fieldSourceTypeId]) !== SourceTypeEnum.TABLE">
              <div class="text-no-wrap">
                <v-chip
                  :color="parseInt(order[fieldSourceTypeId]) < 100 ? 'blue-grey' : 'transparent'"
                  :small="dense"
                  :style="parseInt(order[fieldSourceTypeId]) !== 4 ? parseInt(order[fieldSourceTypeId]) >= 100 ? 'min-width:24px; width: 24px;' : 'min-width:24px;' : 'min-width: 110px;'"
                  class="blue-grey--text text--lighten-3 mr-1 px-0"
                  label
                  style="display: inline-block; text-align: center;"
                >
                  <v-icon
                    v-if="parseInt(order[fieldSourceTypeId]) < 100"
                    size="20"
                  >
                    {{ getOrderSourceTypeById(order[fieldSourceTypeId]).logo }}
                  </v-icon>
                  <img
                    v-else
                    :src="getOrderSourceTypeById(order[fieldSourceTypeId]).logo"
                    height="24"
                  >
                </v-chip>

                <v-chip
                  v-if="parseInt(order[fieldOrderTypeId]) === 1"
                  :small="dense"
                  class="purple--text text--lighten-3 px-1"
                  color="purple"
                  label
                  style="display: inline-block; text-align: center; min-width: 65px;"
                >
                  <v-icon size="16">
                    directions_bike
                  </v-icon>
                  <span class="pl-2">
                    <strong>{{ convertMinutesToDisplayString(order[fieldOrderTypeTime]) }}</strong>
                  </span>
                </v-chip>
                <v-chip
                  v-if="parseInt(order[fieldOrderTypeId]) === 2"
                  :small="dense"
                  class="light-blue--text text--lighten-4 px-1"
                  color="light-blue"
                  label
                  style="display: inline-block; text-align: center; min-width: 65px;"
                >
                  <v-icon size="16">
                    directions_run
                  </v-icon>
                  <span class="pl-2">
                    <strong>{{ order.IsScheduled ? order.ScheduledTimeAt : convertMinutesToDisplayString(order[fieldOrderTypeTime]) }}</strong>
                  </span>
                </v-chip>
              </div>
            </template>

            <v-list-item-subtitle
              class="mt-1 text-center"
              style="white-space: nowrap;"
            >
              <v-chip
                :class="order.IsScheduled ? 'pl-0 pr-1' : 'px-1'"
                :small="dense"
                class="fill-width"
                label
                style="display: inline-block; text-align: center; min-width: 65px;"
              >
                <div
                  v-if="order.IsScheduled"
                  class="mr-1"
                >
                  <v-avatar
                    color="white"
                    tile
                  >
                    <v-icon
                      color="green"
                      size="22"
                    >
                      mdi-clock-time-four
                    </v-icon>
                  </v-avatar>
                </div>

                <span style="font-size: 11px;">{{ order.IsScheduled ? order.ScheduledDateAt : order[fieldTimeAdded] }}</span>
              </v-chip>
            </v-list-item-subtitle>
          </div>

          <v-list-item-content class="grey--text text--darken-1 py-1 align-content-start">
            <slot
              :order="order"
              name="content"
            >
              <v-list-item-title
                v-if="order[fieldFullName].trim()"
                class=""
              >
                <div class="flex-row">
                  <div class="flex-column-shrink">
                    <v-icon
                      :class="[parseInt(order[fieldCustomerId]) === 0 ? 'grey--text' : 'amber--text']"
                      class="text--lighten-2 pb-1"
                      size="16"
                      style="width: 22px;"
                    >
                      verified_user
                    </v-icon>
                  </div>

                  <div class="flex-column-grow">
                    {{ order[fieldFullName] }}
                  </div>
                </div>
              </v-list-item-title>

              <v-list-item-title
                v-else
                class="text-caption"
              >
                <div class="flex-row">
                  <div class="flex-column-shrink">
                    <v-icon
                      :class="[parseInt(order[fieldCustomerId]) === 0 ? 'grey--text' : 'amber--text']"
                      class="text--lighten-2 pb-1"
                      size="16"
                      style="width: 22px;"
                    >
                      verified_user
                    </v-icon>
                  </div>

                  <div class="flex-column-grow">
                    {{ parseInt(order[fieldCustomerId]) === 0 ? $t('Customer.CustomerType.Visitor') : $t('Customer.CustomerType.Registered') }}
                  </div>
                </div>
              </v-list-item-title>

              <v-list-item-subtitle
                v-if="order[fieldAddress]"
                class="text-caption"
              >
                <address-display
                  :address="order[fieldAddress]"
                  icon
                  icon-size="16"
                  style="margin-left: 3px;"
                />
              </v-list-item-subtitle>
            </slot>

            <div
              class="text-end text-no-wrap"
              style="position: absolute; right: 4px; bottom: 8px;"
            >
              <slot
                :order="order"
                name="actions"
              >
                <template v-if="!posUser.eft_pos">
                  <div>
                    <v-btn
                      v-if="directionsAction && order[fieldAddress] && order[fieldAddress]?.Type === AddressTypeEnum.DEFAULT && canDeliverOrder(order)"
                      class="mt-1 ml-1 pl-0 pr-1"
                      color="green darken-3"
                      dark
                      ripple
                      x-small
                      @click.native.stop="onDirectionsActionClick(order)"
                    >
                      <v-avatar
                        class="mr-1 rounded-l"
                        color="green darken-4"
                        size="20"
                        tile
                      >
                        <v-icon small>
                          mdi-directions
                        </v-icon>
                      </v-avatar>

                      {{ $t('Delivery.UserDashboard.Button.Map') }}
                    </v-btn>
                  </div>

                  <v-btn
                    v-if="acceptAction"
                    :disabled="order.LoadingAccept"
                    :loading="order.LoadingAccept"
                    class="mt-1 ml-1 px-1"
                    color="green"
                    dark
                    ripple
                    style="min-width: 0"
                    x-small
                    @click.native.stop="onAcceptActionClick(order)"
                  >
                    {{ $t('Delivery.UserDashboard.Button.Accepted') }}
                  </v-btn>
                  <v-btn
                    v-if="removeAction"
                    :disabled="order.LoadingRemove"
                    :loading="order.LoadingRemove"
                    class="mt-1 ml-1 px-1"
                    color="red"
                    dark
                    ripple
                    style="min-width: 0"
                    x-small
                    @click.native.stop="onRemoveActionClick(order)"
                  >
                    {{ $t('Delivery.UserDashboard.Button.Declined') }}
                  </v-btn>

                  <v-btn
                    v-if="generateDocumentAction && !order.HasFiscalDocument"
                    :disabled="order.IsGeneratingReceipt"
                    :loading="order.IsGeneratingReceipt"
                    class="mt-1 ml-1 px-1"
                    color="amber darken-1"
                    dark
                    ripple
                    style="min-width: 0"
                    x-small
                    @click.native.stop="onGenerateDocumentActionClick(order)"
                  >
                    {{ $t('Common.Button.IssueReceipt') }}
                  </v-btn>
                  <v-btn
                    v-if="printDocumentAction && order.HasFiscalDocument"
                    :disabled="order.LoadingPrint"
                    :loading="order.LoadingPrint"
                    class="mt-1 ml-1 px-1"
                    color="blue"
                    dark
                    ripple
                    style="min-width: 0"
                    x-small
                    @click.native.stop="onPrintDocumentActionClick(order)"
                  >
                    {{ $t('Common.Button.PrintReceipt') }}
                  </v-btn>

                  <v-btn
                    v-if="receiveAction"
                    :disabled="order.LoadingReceive"
                    :loading="order.LoadingReceive"
                    class="mt-1 ml-1 px-1"
                    color="purple"
                    dark
                    ripple
                    style="min-width: 0"
                    x-small
                    @click.native.stop="onReceiveActionClick(order)"
                  >
                    {{ $t('Delivery.UserDashboard.Button.Received') }}
                  </v-btn>
                </template>

                <template v-if="deliverAction || posUser.eft_pos">
                  <template v-if="canPayOrder(order) && !isOrderPaid(order)">
                    <v-btn
                      v-if="!posUser.eft_pos && (order.CanNotifyDelivery || (!order.CanNotifyDelivery && order.DeliveryStaffNotifyAt))"
                      :disabled="order.notifyDeliveryIsLoading || !order?.CanNotifyDelivery"
                      :loading="order.notifyDeliveryIsLoading"
                      class="mt-1 ml-1 pl-0 pr-1 white--text"
                      color="purple"
                      ripple
                      style="min-width: 0"
                      x-small
                      @click.native.stop="orderNotifyCustomerOrderCollect(order, OrderNotifyFromEnum.DELIVERY_DASHBOARD)"
                    >
                      <v-avatar
                        class="rounded-l mr-1 purple darken-4"
                        color=""
                        size="20"
                        tile
                      >
                        <v-icon
                          :class="order.DeliveryStaffNotifyAt ? 'success' : 'purple lighten-2'"
                          small
                        >
                          {{ order.DeliveryStaffNotifyAt ? 'mdi-check-bold' : 'mdi-send' }}
                        </v-icon>
                      </v-avatar>

                      {{ $t('Common.Button.Notify') }}
                    </v-btn>

                    <v-btn
                      class="mt-1 ml-1 px-1"
                      color="primary"
                      dark
                      ripple
                      style="min-width: 0"
                      x-small
                      @click.native.stop="onOrderPayClick(order)"
                    >
                      {{ $t('Common.Button.Payment') }}
                    </v-btn>
                  </template>

                  <v-btn
                    v-else-if="!posUser.eft_pos && (isOrderPaid(order) || !isOrderPayable(order))"
                    :disabled="order.LoadingDeliver"
                    :loading="order.LoadingDeliver"
                    class="mt-1 ml-1 px-1"
                    color="green"
                    dark
                    ripple
                    style="min-width: 0"
                    x-small
                    @click.native.stop="onDeliverActionClick(order)"
                  >
                    {{ $t('Delivery.UserDashboard.Button.Delivered') }}
                  </v-btn>
                </template>
              </slot>
            </div>
          </v-list-item-content>

          <v-list-item-action class="py-1 my-0 ml-2">
            <slot
              :order="order"
              name="price"
            >
              <v-list-item-action-text class="text-subtitle-1 font-weight-bold">
                {{ order[fieldOrderTotal] | currency }}
              </v-list-item-action-text>
            </slot>
          </v-list-item-action>
        </v-list-item>

        <div :key="`actions-${order[fieldOrderId]}`" />

        <v-divider
          :key="`divider-${order[fieldOrderId]}`"
          class="mb-1"
        />
      </template>
    </v-list>

    <order-payment-dialog
      v-if="selectedOrder"
      :customer-email="selectedOrder.Email"
      :customer-id="selectedOrder.CustomerId"
      :order="selectedOrder"
      :order-id="selectedOrder.Id"
      :order-total="selectedOrder.OrderTotal"
      :payload="{autoPrint: true}"
      :source-type="selectedOrder.SourceTypeId"
      :transactions="selectedOrder.PaymentTransactions"
      :visible.sync="orderPaymentDialogVisible"
      receipt
    />
  </div>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import paymentType from '@/mixins/orders/paymentType'
import OrderCommon from '@/mixins/orders/common'
import OrderSourceType from '@/mixins/orders/sourceType'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum'
import OrderPaymentDialog from '@/components/payments/orders/OrderPaymentDialog.vue'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'
import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum'
import OrderStatusEnum from '@/api/Enums/OrderStatusEnum'
import OrderTypeEnum from '@/api/Enums/OrderTypeEnum'
import {clone} from '@/lib/helper/helper.js'
import AddressDisplay from '@/components/common/AddressDisplay.vue'
import AddressTypeEnum from '@/api/Enums/AddressTypeEnum.js'
import OrderNotifyFromEnum from '@/api/Enums/OrderNotifyFromEnum.js'

export default {
  name      : 'DeliveryUserOrdersVList',
  components: {AddressDisplay, OrderPaymentDialog},
  directives: {},
  mixins    : [AppData, Auth, paymentType, OrderCommon, OrderSourceType],
  props     : {
    orders: {
      type    : Array,
      default : () => [],
      required: true
    },
    fieldOrderId: {
      type   : String,
      default: 'Id'
    },
    fieldOrderCode: {
      type   : String,
      default: 'OrderCode'
    },
    fieldFullName: {
      type   : String,
      default: 'FullName'
    },
    fieldCustomerId: {
      type   : String,
      default: 'CustomerId'
    },
    fieldAddress: {
      type   : String,
      default: 'Address'
    },
    fieldAddressFormatted: {
      type   : String,
      default: 'AddressFormatted'
    },
    fieldDateAdded: {
      type   : String,
      default: 'DateAdded'
    },
    fieldTimeAdded: {
      type   : String,
      default: 'TimeAdded'
    },
    fieldOrderTotal: {
      type   : String,
      default: 'OrderTotal'
    },
    fieldStatusId: {
      type   : String,
      default: 'StatusId'
    },
    fieldOrderTypeId: {
      type   : String,
      default: 'OrderTypeId'
    },
    fieldOrderTypeTime: {
      type   : String,
      default: 'OrderTypeTime'
    },
    fieldSourceTypeId: {
      type   : String,
      default: 'SourceTypeId'
    },

    listTileClickEvent: {
      type   : String,
      default: 'list-tile-click'
    },
    removeActionClickEvent: {
      type   : String,
      default: 'remove-action-click'
    },
    directionsActionClickEvent: {
      type   : String,
      default: 'directions-action-click'
    },
    acceptActionClickEvent: {
      type   : String,
      default: 'accept-action-click'
    },
    receiveActionClickEvent: {
      type   : String,
      default: 'receive-action-click'
    },
    generateDocumentActionClickEvent: {
      type   : String,
      default: 'generate-document-action-click'
    },
    printDocumentActionClickEvent: {
      type   : String,
      default: 'print-document-action-click'
    },
    deliverActionClickEvent: {
      type   : String,
      default: 'deliver-action-click'
    },
    acceptAction: {
      type   : Boolean,
      default: false
    },
    receiveAction: {
      type   : Boolean,
      default: false
    },
    generateDocumentAction: {
      type   : Boolean,
      default: false
    },
    printDocumentAction: {
      type   : Boolean,
      default: false
    },
    deliverAction: {
      type   : Boolean,
      default: false
    },
    removeAction: {
      type   : Boolean,
      default: false
    },
    reorderAction: {
      type   : Boolean,
      default: false
    },
    directionsAction: {
      type   : Boolean,
      default: false
    },

    dense: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    OrderNotifyFromEnum() {
      return OrderNotifyFromEnum
    },
    AddressTypeEnum() {
      return AddressTypeEnum
    },
    OrderTypeEnum() {
      return OrderTypeEnum
    },
    FiscalDocsProviderTypeEnum() {
      return FiscalDocsProviderTypeEnum
    },
    PaymentTypeEnum() {
      return PaymentTypeEnum
    },
    SourceTypeEnum() {
      return SourceTypeEnum
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on(window.SocketCommand.Order.Payment.Transaction.ChangePaymentType, this.onChangePaymentTypeResult)
    this.$bus.$on(window.SocketCommand.Receipt.PaymentUpdate, this.updateFiscalDocumentPaymentResult)
    this.$bus.$on(window.SocketCommand.Order.Payment.Transaction.OrderResult, this.onPaymentTransactionResult)
    this.$bus.$on(window.SocketCommand.Staff.Delivery.User.ShiftUpdate, this.onOrdersUpdateResult)
    this.$bus.$on(window.SocketCommand.Receipt.Generate, this.onGenerateReceiptResult)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  activated() {
  },
  deactivated() {
  },
  beforeDestroy() {
    this.$bus.$off(window.SocketCommand.Order.Payment.Transaction.ChangePaymentType, this.onChangePaymentTypeResult)
    this.$bus.$off(window.SocketCommand.Receipt.PaymentUpdate, this.updateFiscalDocumentPaymentResult)
    this.$bus.$off(window.SocketCommand.Order.Payment.Transaction.OrderResult, this.onPaymentTransactionResult)
    this.$bus.$off(window.SocketCommand.Staff.Delivery.User.ShiftUpdate, this.onOrdersUpdateResult)
    this.$bus.$off(window.SocketCommand.Receipt.Generate, this.onGenerateReceiptResult)
  },
  destroyed() {
  },
  methods: {
    onGenerateReceiptResult(payload) {
      if (payload?.status === 'success') {
        this.orderPaymentDialogVisible = false
        this.selectedOrder = null
        this.$emit('update-orders')
      }
    },

    updateFiscalDocumentPaymentResult(result, payload) {
      if (result?.status === 'success') {
        if (result?.Success === false) {
          this.$bus.$emit('app-show-notification', {
            body   : this.$t('Common.Misc.Notification.DeliveryPaymentComplete.Error'),
            type   : 'error',
            icon   : 'warning',
            timeout: 6000
          })
        } else {
          this.orderPaymentDialogVisible = false
          this.selectedOrder = null
          this.$emit('update-orders')

          this.$bus.$emit('app-show-notification', {
            body: this.$t('Common.Misc.Notification.DeliveryPaymentComplete.Success'),
            type: 'success',
            icon: 'check'
          })
        }
      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Misc.Notification.DeliveryPaymentComplete.Error'),
          type   : 'error',
          icon   : 'warning',
          timeout: 6000
        })
      }

    },

    onChangePaymentTypeResult(payload) {
      if (payload?.status === 'success') {
        this.$emit('update-orders')

        this.$bus.$emit('app-show-notification', {
          body: this.$t('Common.Misc.Notification.DeliveryPaymentConvert.Success'),
          type: 'success',
          icon: 'check'
        })

      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Misc.Notification.DeliveryPaymentConvert.Error'),
          type   : 'error',
          icon   : 'warning',
          timeout: 6000
        })
      }
    },

    onPaymentTransactionResult(payload) {
      if (!payload || !this.selectedOrder) return
      this.$emit('update-orders')
      //this.$bus.$emit('add-payment-loader-stop')
    },

    onOrdersUpdateResult(data) {
      if (!data || !this.selectedOrder) return

      const orders = data?.Shift?.ShiftOrders || []
      const order = orders.find(o => parseInt(o.Id) === parseInt(this.selectedOrder.Id))

      if (order) this.updateOpenOrder(order)
    },

    canDeliverOrder(order) {
      if (!order) return false
      return parseInt(order.OrderTypeId) === OrderTypeEnum.DELIVERY && order?.Address?.Type !== AddressTypeEnum.INTERNAL_OFFICE && !!order.Address?.Lat && !!order.Address?.Lng
    },

    canPayOrder(order) {
      return this.isOrderPayable(order)
          && !this.isOrderPaid(order)
          && (this.posUser.eft_pos || (order.DeliveryStaffAdded && order.DeliveryStaffAccepted && order.DeliveryStaffReceived && !order.DeliveryStaffDelivered))
    },

    isOrderPayable(order) {
      return this.appHasFiscalDocsProvider
          && this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD
          && this.posUser.Settings.DeliveryStaff.Permissions.CanTransactionSale
          && !order.DeliveryStaffCompleted
          && order?.PaymentTransactions?.some(transaction => PaymentTypeEnum.isMethodDeliveryStaffOrderPayable(transaction.PaymentType))
    },

    isOrderPaid(order) {
      return this.isOrderPayable(order) && order.DeliveryStaffCompleted && order.PaymentTransactions
        ?.filter(transaction => transaction.PaymentType === PaymentTypeEnum.DELIVERY)
        ?.every(transaction => this.eftPosCardTransactionPaidSuccessful(transaction))
    },

    updateOpenOrder(order) {
      if (order && this.selectedOrder && this.selectedOrder.Id === order.Id) {
        this.selectedOrder = clone(order)
        this.orderPaymentDialogVisible = true
      }
    },

    onOrderNotifyCustomerClick(order) {
      if (!order || order.notifyDeliveryIsLoading) return

      this.$set(order, 'notifyDeliveryIsLoading', true)

      window.callAS(window.SocketCommand.Order.DeliveryNotify, {OrderId: order.Id, OrderCode: order.OrderCode})
    },

    onOrderPayClick(order) {
      this.$emit('update-orders')

      if (order) {
        this.selectedOrder = clone(order)
        this.orderPaymentDialogVisible = true
      } else {
        this.selectedOrder = null
        this.orderPaymentDialogVisible = false
      }
    },

    onListTileClick(order) {
      this.$emit(this.listTileClickEvent, order)
    },

    onRemoveActionClick(order) {
      this.$set(order, 'LoadingRemove', true)
      this.$emit(this.removeActionClickEvent, order)
    },

    onDirectionsActionClick(order) {
      this.$emit(this.directionsActionClickEvent, order)
    },

    onAcceptActionClick(order) {
      this.$set(order, 'LoadingAccept', true)
      this.$emit(this.acceptActionClickEvent, order, OrderStatusEnum.Accepted)
    },

    onReceiveActionClick(order) {
      this.$set(order, 'LoadingReceive', true)
      this.$emit(this.receiveActionClickEvent, order, OrderStatusEnum.Received)
    },

    onGenerateDocumentActionClick(order) {
      this.$set(order, 'IsGeneratingReceipt', true)
      this.$emit(this.generateDocumentActionClickEvent, order)
    },

    onPrintDocumentActionClick(order) {
      this.$set(order, 'LoadingPrint', true)
      this.$emit(this.printDocumentActionClickEvent, order)
    },

    onDeliverActionClick(order) {
      this.$set(order, 'LoadingDeliver', true)
      this.$emit(this.deliverActionClickEvent, order, OrderStatusEnum.Delivery)
    }
  }
}
</script>

<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
}

.flex-column-shrink {
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
}

.flex-column-grow {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex: 1;
}

:deep(.v-list__tile) {
  padding: 0 8px;
}

:deep(.v-chip__content) {
  padding: 0;
}
</style>
